module.exports = __webpack_public_path__ + "static/media/drums.4ea09ed1.png";